import { Link } from 'react-router-dom';
import { useCart } from './CartContext';
import {
  termLabel,
  termCadence,
  usd,
  seatCountsForTerm,
  termsIn,
} from './priceFormat';
import './hierarchy.css';

function CartPage() {
  const { item, updateItem, clear, unitPrice } = useCart();

  if (!item) {
    return (
      <div className="page">
        <h1 className="page-title">Your Cart</h1>
        <p className="empty-text">
          Your cart is empty. <Link className="text-link" to="/products">Browse products</Link>.
        </p>
      </div>
    );
  }

  const terms = termsIn(item.prices);
  const seatCounts = seatCountsForTerm(item.prices, item.term);

  // Switching term may land on a seat count that term doesn't offer — keep the
  // same seat count when available, otherwise fall back to the term's smallest.
  const handleTermChange = nextTerm => {
    const seatsForTerm = seatCountsForTerm(item.prices, nextTerm);
    const seatCount = seatsForTerm.includes(item.seatCount) ? item.seatCount : seatsForTerm[0];
    updateItem({ term: nextTerm, seatCount });
  };

  const handleSeatChange = nextSeats => updateItem({ seatCount: nextSeats });

  return (
    <div className="page">
      <h1 className="page-title">Your Cart</h1>

      <div className="item-stack cart-lines">
        <article className="item-card cart-line">
          {item.imageUrl ? (
            <img className="cart-line-image" src={item.imageUrl} alt="" loading="lazy" />
          ) : null}
          <Link className="item-title cart-line-title" to={`/products/${item.productId}`}>
            {item.productName}
          </Link>

          <label className="cart-control">
            <span className="cart-control-label">Term</span>
            <select
              className="input"
              value={item.term}
              onChange={e => handleTermChange(Number(e.target.value))}
            >
              {terms.map(t => (
                <option key={t} value={t}>{termLabel(t)}</option>
              ))}
            </select>
          </label>

          <label className="cart-control">
            <span className="cart-control-label">Seats</span>
            <select
              className="input"
              value={item.seatCount}
              onChange={e => handleSeatChange(Number(e.target.value))}
            >
              {seatCounts.map(sc => (
                <option key={sc} value={sc}>{sc}</option>
              ))}
            </select>
          </label>

          <div className="cart-line-price">{usd.format(unitPrice)}</div>
          <button type="button" className="btn btn--danger cart-line-remove" onClick={clear}>
            Remove
          </button>
        </article>
      </div>

      <div className="cart-summary">
        <div className="cart-summary-lines">
          <div className="cart-summary-row">
            <span className="cart-summary-label">Due now</span>
            <span className="cart-summary-total">
              {usd.format(unitPrice)} <span className="cart-summary-tax">+ tax</span>
            </span>
          </div>
          <p className="note">
            Then billed {termCadence(item.term)} at {usd.format(unitPrice)} + tax
          </p>
          <p className="note note--italic">No commitment — cancel your subscription anytime.</p>
          <p className="note note--italic">Tax calculated at checkout.</p>
        </div>
      </div>

      <div className="cart-actions">
        <Link to="/products" className="btn btn--outlined">Continue shopping</Link>
        <Link to="/checkout" className="btn btn--filled">Proceed to checkout</Link>
      </div>
    </div>
  );
}

export default CartPage;
